import { createTRPCProxyClient, httpBatchLink } from "@trpc/client";
import type { AppRouter } from "~/AppRouterType";
import { environment } from "~/environment";

function initTRPC() {
  return createTRPCProxyClient<AppRouter>({
    links: [httpBatchLink({ url: environment.TRPC_URL })],
  });
}

let tRPC: ReturnType<typeof initTRPC>;

export function getTRPC(): ReturnType<typeof initTRPC> {
  if (tRPC) {
    return tRPC;
  }

  tRPC = initTRPC();
  return tRPC;
}
